import { Outlet } from "react-router-dom";

export function AuthPage() {
  // if (!getToken()) {
  //   return <Navigate to="/" />;
  // }

  return <Outlet />;
}
